import { PublicData } from "./types";
import api from "./axiosConfig";

const BASE_PATH = "portal";

const portalPublicService = {
  getPublicData: async (regionId: string) => {
    try {
      const response = await api.get<PublicData>(
        `${BASE_PATH}/publicdata?regionId=${regionId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching public data:", error);
      throw error;
    }
  },
};

export default portalPublicService;
